<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-17 16:49:15
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-24 18:39:41
 * @FilePath: /dsicm-admin-web/src/views/scoentific/components/caseHeader-1/index.vue
-->
<template>
  <header>
    <publicBreadCrumb :breadList="breadList" />
    <el-form inline size="small" :model="seachFormData">
      <el-form-item>
        <el-input prefix-icon="el-icon-search" placeholder="请输入项目名称" v-model="seachFormData.searchCondition">
        </el-input>
      </el-form-item>

      <el-form-item label="项目学科分类:" label-width="100px">
        <el-select @change="projectListChange" v-model="projectListId" placeholder="请选择一级类别">
          <el-option v-for="item in projectList" :key="item.id" :label="item.categoryName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select v-model="leftPlatformListId" placeholder="请选择二级类别">
          <el-option v-for="item in leftPlatformList" :key="item.id" :label="item.categoryName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button @click="resetHandel">重置</el-button>
        <el-button type="primary" @click="inquireHeader" style="background:#1A7BFC">搜索</el-button>
      </el-form-item>

    </el-form>
  </header>
</template>

<script>
import { apistandardCategory, apiApplyItem } from "../../api";
export default {
  name: "CaseHeader-1",
  data() {
    return {
      breadList: [{ name: "科研管理" }, { name: "已申请科研管理" }],
      seachFormData: {
        size: 10,
        current: 1,
        searchCondition: "", //项目名称
        firstCategoryCode: "",
        secondCategoryCode: ""
      },
      projectListId: "",
      leftPlatformListId: "",
      projectList: [],
      leftPlatformList: []
    };
  },
  mounted() {
    this.init();
    //TODO init为true来判断是否第一次加载
    this.$emit("inquire", { ...this.seachFormData, init: true });
  },
  methods: {
    /**
     * @description:重置
     * @param {*}
     * @return {*}
     */
    resetHandel() {
      this.seachFormData = this.$options.data().seachFormData;
      (this.projectListId = ""),
        (this.leftPlatformListId = ""),
        this.$emit("reset", this.seachFormData);
    },
    /**
     * @description: 搜索
     * @param {*}
     * @return {*}
     */

    inquireHeader() {
      if (
        this.projectListId &&
        this.projectList.filter(item => item.id == this.projectListId)
      ) {
        this.seachFormData.firstCategoryCode = this.projectList.filter(
          item => item.id == this.projectListId
        )[0].categoryCode;
      }

      if (
        this.leftPlatformList.length &&
        this.leftPlatformList.filter(item => item.id == this.leftPlatformListId)
          .length
      ) {
        this.seachFormData.secondCategoryCode = this.leftPlatformList.filter(
          item => item.id == this.leftPlatformListId
        )[0].categoryCode;
      }
      this.$emit("inquire", this.seachFormData);
    },
    /**
     * @description: 项目学科分类 change事件
     * @param {*}
     * @return {*}
     */
    projectListChange(e) {
      this.leftPlatformList = [];
      this.leftPlatformListId = "";
      apistandardCategory({
        parentId: e,
        type: 5,
        status: false
      }).then(res => {
        if (res.code == 0) {
          this.leftPlatformList = res.data;
        }
      });
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */

    init() {
      apistandardCategory({
        parentId: 0,
        type: 5,
        status: false
      }).then(res => {
        if (res.code == 0) {
          this.projectList = res.data;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
header {
  height: 126px;
  padding: 0 24px;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 16px solid #f8f8f8;
  .text {
    margin-bottom: 20px;
    color: #333333;
    font-size: 14px;
    span:nth-child(2) {
      color: #000000;
    }
    span:nth-child(1) {
      color: #666666;
    }
  }
  & /deep/ .el-button--default {
    color: rgb(26, 123, 252);
  }
  & /deep/ .el-button--default:hover {
    background: rgb(26, 123, 252);
    color: #fff;
  }
}
.el-form {
  & /deep/.el-form-item__label {
    color: #333333;
    font-size: 12px;
  }
}
</style>